import React from 'react';

const EmptyComponent = () => <div />;

export default EmptyComponent;
